export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/aPL7EBcECgRwTVWTVGP7v3/PAGINA_8.jpg',
    alt: 'Sample page Latent Heat Changes Phase, Not Temperature, showing the heating curve of water with sensible heat, latent heat and superheat',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eXqXRxdZn7MxiuiZAjJ8VF/PAGINA_14.jpg',
    alt: 'Sample page Hot Surfaces Radiate Heat Without Touching Anything, explaining thermal radiation with a technical warning about radiant heat',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eT2pCmQkPg8G7Hik4zB7Qd/PAGINA_23.jpg',
    alt: 'Sample page A Steam Table Answers Four Questions at Once, showing how to read a saturated steam table',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oKTTRp36ryuNnCPsxfnSwv/PAGINA_34.jpg',
    alt: 'Sample page The Process User Is Why the Whole System Exists, comparing heat exchangers, jacketed vessels, coils and direct steam injection',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/byWLrhM4VMk8UMogaDvSie/PAGINA_47.jpg',
    alt: 'Sample page How Much Steam Does a Tank Heat-Up Need, a practical case sizing the energy balance for a process tank',
  },
];
